<template>
  <CrudForm
    :title="title"
    :labelSubmit="labelSubmit"
    :storeName="storeName"
    :submit="submit"
    labelBack="Atrás"
    parentStoreName="Countries"
    :labelCancel="labelCancel"
  >
    <ValidationObserver ref="validator" v-slot="{}">
      <v-row justify="center">
        <v-col cols="8">
          <v-row>
            <v-col>
              <ValidationProvider
                ref="name"
                rules="required"
                v-slot="{ errors }"
              >
                <v-text-field
                  id="pac-input"
                  :error-messages="errors"
                  v-model="data.name"
                  label="País"
                  prepend-inner-icon="fas fa-file"
                ></v-text-field>
              </ValidationProvider>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <ValidationProvider ref="icon" rules="" v-slot="{ errors }">
                <Upload
                  :error-messages="errors"
                  accept="image/png, image/jpeg, image/jpg"
                  placeholder="Icono"
                  prepend-icon="fas fa-camera"
                  label=""
                  :multiple="false"
                  :onSelectedPicture="onSelectedPicture"
                ></Upload>
                <v-img :src="icon" width="200" style="margin: auto"></v-img>
              </ValidationProvider>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <ValidationProvider
                ref="utc_difference"
                rules="required|min_value:-12|max_value:12"
                v-slot="{ errors }"
              >
                <v-select
                  :error-messages="errors"
                  v-model="data.utc_difference"
                  prepend-inner-icon="fas fa-clock"
                  :items="
                    Array.from({ length: 25 }, (v, i) => i - 12).map(i => {
                      return { id: i, name: `UTC ${i >= 0 ? '+' : ''}${i}` };
                    })
                  "
                  item-text="name"
                  item-value="id"
                  label="Diferencia UTC"
                ></v-select>
              </ValidationProvider>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </ValidationObserver>
  </CrudForm>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { mapState } from "vuex";
import Upload from "@/components/Upload";
import CrudForm from "@/components/Crud/CrudForm";
import CrudFormMixin from "@/mixins/crud_form";

export default {
  mixins: [CrudFormMixin],
  components: { ValidationProvider, ValidationObserver, CrudForm, Upload },
  computed: {
    ...mapState({})
  },
  data() {
    return {
      storeName: "Countries",
      title: "Países",
      filteredAttributes: ["icon"],
      icon: "",
      data: {
        name: "",
        icon: undefined,
        utc_difference: 0
      }
    };
  },
  methods: {
    onSelectedPicture(file) {
      const self = this;
      this.data.icon = file;

      let fr = new FileReader();
      fr.onload = function() {
        self.icon = fr.result;
      };
      fr.onerror = function() {
        self.icon = "";
      };
      fr.readAsDataURL(this.data.icon);
    }
  }
};
</script>
